import { configureTheming } from "@tal-gel/theming";
import ThemingPluginTal from "@tal-gel/theming-plugin-tal";

configureTheming({
  plugins: [
    ThemingPluginTal, // Add TAL theme to tal-gel
  ],
});
